module.exports = __webpack_public_path__ + "static/media/logo.d5a042a1.png";